import { RouteConfig } from "vue-router";

import OperationMonitorPage from "@/features/operationMonitor/pages/OperationMonitorPage.vue";

export const DashboardRouter: (prefix?: string) => RouteConfig[] = (prefix = "dashboard") => [
  {
    name: "OperationMonitorPage",
    path: `${prefix}/operation-monitor`,
    component: OperationMonitorPage,
    meta: { title: "Operation Monitor" },
    beforeEnter: (to, from, next) => {
      const { meta } = to;
      document.title = meta?.title;
      next();
    },
  },
];
